// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2026-09-29
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import deepCopy from "src/utilities/deepCopy";

const initialState: Notification[] = [];

// A Redux slice for managing notifications.
const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<Notification[]>) => action.payload,
    toggleNotification: (state, action: PayloadAction<number>) => {
      const payload = action.payload;
      const notificationsDeepCopy = deepCopy(state);
      const targetNotification = notificationsDeepCopy.find((notification) => notification.alertMessageId === payload);
      if (targetNotification !== undefined) {
        targetNotification.unread = !targetNotification.unread;
      }
      return notificationsDeepCopy;
    },
    toggleAllNotifications: (state) => {
      const notificationsDeepCopy = deepCopy(state);
      let allRead = true;
      notificationsDeepCopy.forEach((notification) => {
        if (notification.unread) {
          allRead = false;
        }
      });
      notificationsDeepCopy.forEach((notification) => (notification.unread = allRead));
      return notificationsDeepCopy;
    },
    deleteNotification: (state, action: PayloadAction<number>) => {
      const payload = action.payload;
      const notificationsDeepCopy = deepCopy(state);
      const notificationIndex = notificationsDeepCopy.findIndex(
        (notification) => notification.alertMessageId === payload
      );
      if (notificationIndex !== -1) {
        notificationsDeepCopy.splice(notificationIndex, 1);
      }
      return notificationsDeepCopy;
    },
    deleteAllNotifications: () => [],
  },
});

export const {
  setNotifications,
  toggleNotification,
  toggleAllNotifications,
  deleteNotification,
  deleteAllNotifications,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;

interface Notification {
  alertMessageId: number;
  alertCode: string;
  date: string;
  message: string;
  unread: boolean;
  urgency: string;
  alertUrl: string;
}
